export default __webpack_public_path__ + "static/image-3-95ac3c3141a9eee3cae3794704f2a3b5.png";